import { FEATURE_PERMISSIONS, canViewAllData, canModifyData } from './permissions';
import { createCustomerLookup, isAssignedCustomer } from './reportOwnership';

export function canViewAllEmail(user, can) {
  if (!user || user.role === 'disabled') return false;
  if (canViewAllData(user)) return true;
  if (user?.permissionDenials?.includes(FEATURE_PERMISSIONS.EMAIL_VIEW_ALL)) return false;
  return ['manager', 'marketing'].includes(user?.role) || can(FEATURE_PERMISSIONS.EMAIL_VIEW_ALL);
}

export function canManageEmailTemplate(user, can, template, permission) {
  return canModifyData(user) && can(permission) &&
    (canViewAllEmail(user, can) || !template || template.createdBy === user?.uid);
}

export function scopeEmailAudience(data, user, viewAll) {
  if (viewAll) return data;
  const customers = data.customers.filter(customer => isAssignedCustomer(customer, user));
  const lookup = createCustomerLookup(customers);
  return {
    customers,
    contacts: data.contacts.filter(contact => lookup.forAccount(contact.customerId)),
    opportunities: data.opportunities.filter(opportunity => lookup.forAccount(opportunity.customerId)),
  };
}
